import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Industries from "@/components/site/Industries";
import Statistics from "@/components/site/Statistics";
import Method from "@/components/site/Method";
import PipelineSection from "@/components/site/PipelineSection";
import ROICalculator from "@/components/site/ROICalculator";
import Pricing from "@/components/site/Pricing";
import Applications from "@/components/site/Applications";
import ESGReporting from "@/components/site/ESGReporting";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import CookieConsent from "@/components/CookieConsent";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import Seo from "@/components/Seo";

const TOASTER_OPTIONS = {
  style: {
    background: '#ffffff',
    border: '1px solid rgba(8, 145, 178, 0.25)',
    color: '#0f172a',
    fontFamily: 'IBM Plex Sans, sans-serif',
  },
};

const Home = () => {
  return (
    <div className="bg-[#f6f7f9] text-slate-900 min-h-screen">
      <Seo
        title="Ultraschall-Leckageortung für Druckluft &amp; Prozessgase"
        description="Modernste High-End-Ultraschall-Messtechnik detektiert Druckluft-, Stickstoff- und Argon-Lecks im laufenden Betrieb. Volumenstrom in m³/h, Energieverlust in kWh/Jahr und Kosten in €/Jahr pro Leck. ISO 50001 konforme Berichte. MIBAX Messtechnik, München – Service in DACH."
        path="/"
      />
      <Header />
      <main>
        <Hero />
        <Industries />
        <Statistics />
        <Method />
        <PipelineSection />
        <Applications />
        <ROICalculator />
        <ESGReporting />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={TOASTER_OPTIONS}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
